/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Container, Flex, Box, Text, Image, Center } from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'
import { ActiveStepper, InactiveStepper } from './StepperComponents'
import {
  useGetJourneyDetailsQuery,
  useGetUserRemarksQuery,
  useGetUserStateQuery,
} from 'Services/API/posp.api'
import { USER_BROKER_TYPE, USER_REGISTRATION_TYPE } from 'Constants'
import { updateUserActiveKey, updateUserState } from 'features/Authentication'
import { PospHeader } from 'Components/PospHeader'
import { PospImages } from 'Assets/Posp'
import { useNavigate } from 'react-router-dom'
import { useDeviceType } from 'app/hooks'
import { IoIosMail } from 'react-icons/io'
import { BsFillTelephoneFill } from 'react-icons/bs'
import PospFooter from 'Components/PospFooter'

const RegistrationStatus = () => {
  const store = useSelector((state: any) => state.user)
  const isAlreadyRegistered: any = false
  const {
    userState: userStateFromStore,
    broker,
    authenticatedUser,
    journeyType,
  } = store

  const navigate = useNavigate()

  const { isMobile } = useDeviceType()

  const { data: userJourneyResponse } = useGetJourneyDetailsQuery(
    {},
    {
      refetchOnMountOrArgChange: true,
    },
  )

  const userJourneyData = userJourneyResponse?.data || {}

  const dispatch = useDispatch()

  const [userState, setUserState] = useState<any>(userStateFromStore)
  const [changeUserState, setChangeUserState] = useState(false)
  const [activeRow, setActiveRow] = useState('pan_iib_verification')
  const [mapUserState, setMapUserState] = useState(false)

  const PreviousStatusCheck = (checkStatusKey: string) => {
    let isChecked = true
    let stopLoop = false
    if (userState[checkStatusKey].prev === 'NONE') return true

    Object.keys(userState).forEach((key) => {
      if (key === checkStatusKey) {
        stopLoop = true
      }

      if (stopLoop) {
        return
      }
      if (userState[key].status === 'INCOMPLETE') {
        isChecked = false
      }
    })

    return isChecked
  }

  useEffect(() => {
    if (isAlreadyRegistered === USER_REGISTRATION_TYPE.registered) {
      const registeredUserState = Object.fromEntries(
        Object.entries(userState).filter(
          ([key, value]) => key !== 'training_module' && key !== 'general_insu_exam',
        ),
      )

      setUserState(registeredUserState)
    }

    setMapUserState(!mapUserState)
  }, [isAlreadyRegistered, userJourneyData])

  useEffect(() => {
    Object.keys(userJourneyData).forEach((key) => {
      // if (
      //   isAlreadyRegistered === USER_REGISTRATION_TYPE.registered &&
      //   (key === 'training_module' || key === 'general_insu_exam')
      // ) {
      //   return
      // }

      setUserState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          status: userJourneyData[key].status,
          message: userJourneyData[key].message,
        },
      }))
    })

    setChangeUserState(!changeUserState)
  }, [mapUserState])

  useEffect(() => {
    Object.keys(userState).forEach((key) => {
      if (PreviousStatusCheck(key)) {
        if (
          key === 'final_iib_verification' &&
          (userState[key].status === 'COMPLETE' || userState[key].status === 'REJECTED')
        ) {
          setActiveRow('NONE')
          dispatch(updateUserActiveKey('NONE'))
        } else {
          setActiveRow(key)
          dispatch(updateUserActiveKey(key))
        }
      }
    })

    dispatch(updateUserState(userState))
    // dispatch(updateUserActiveKey(activeRow))
  }, [changeUserState])

  // useEffect(() => {
  //   if (!broker) {
  //     navigate('/sp-registration/is-registered/status')
  //   }
  // }, [broker])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])
  // const activeRow = 2;
  return (
    <Box backgroundColor='#F6F6F6' minH='100vh'>
      <PospHeader />
      <Container maxWidth={isMobile ? 'sm' : '90%'} minH='100%'>
        <Text my={5} color='#11558E' fontSize={isMobile ? 'md' : '40px'} fontWeight='light'>
          Registration Status
        </Text>
        <Flex
          direction={isMobile ? 'column' : 'row'}
          borderRadius={isMobile ? '10px' : '0'}
          border={isMobile ? '1px solid #cfcfcf' : 'none'}
          backgroundColor='#fff'
          minH='78vh'
        >
          <Center
            width='full'
            flexBasis='30%'
            borderBottom={isMobile ? '1px solid #cfcfcf' : 'none'}
            borderRight={!isMobile ? '1px solid gray' : 'none'}
          >
            <Flex
              padding={'10px'}
              justifyContent={'center'}
              alignItems={'center'}
              flexDirection={'column'}
              width='full'
              // borderRadius="full"
              // border="dashed 4px #B5B5B5"
            >
              {!isMobile && <Image src={PospImages.UserIcon} />}
              <Flex
                width={isMobile ? 'full' : 'auto'}
                justifyContent='space-between'
                alignItems={'center'}
                direction={isMobile ? 'row' : 'column'}
              >
                <Text
                  fontWeight={isMobile ? 'semibold' : 'bold'}
                  mt={isMobile ? 0 : 5}
                  fontSize={isMobile ? 'sm' : 'xl'}
                >
                  {authenticatedUser?.first_name} {authenticatedUser?.last_name}
                </Text>
                {authenticatedUser?.pan_number ? (
                  <Text fontSize={'xs'}>Pan Number: {authenticatedUser?.pan_number}</Text>
                ) : null}
              </Flex>
            </Flex>
          </Center>
          <Box className='steppers' flexBasis='70%'>
            <br />
            {Object.keys(userState).map((val: any, ind: any) => {
              if (val === 'agreement_generated') return
              const stepValues =
                val === 'general_insu_exam'
                  ? {
                      ...userState[val],
                      key:
                        journeyType === 'LIFE' ? 'Life Insurance exam' : 'General Insurance exam',
                      subhead:
                        journeyType === 'LIFE'
                          ? 'Proceed with Life Insurance exam'
                          : 'Proceed with General Insurance exam',
                    }
                  : userState[val]
              if (activeRow === val) {
                return (
                  <div key={ind}>
                    <ActiveStepper key={ind} state={val} values={stepValues} />
                  </div>
                )
              } else {
                return (
                  <div key={ind}>
                    <InactiveStepper state={val} values={stepValues} />
                  </div>
                )
              }
            })}
          </Box>
        </Flex>
      </Container>
      <PospFooter />
    </Box>
  )
}

export default RegistrationStatus
